import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'claimStatus'
})
export class ClaimStatusPipe implements PipeTransform {

  transform(value: any): any {
    switch (value) {
      case 0:
        return 'Pending';
      case 1:
        return 'Assigned';
      case 2:
        return 'Approved';
      case 3:
        return 'Declined';
      case 4:
        return 'Waiting for AES';
      case 5:
        return 'EEI Received';
      case 6:
        return 'Pending'; // 'Pending for Correction';
      default:
        return value;
    }
  }

}
